import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Error from "@/components/Error.tsx";

const ErrorPage = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Error
      type={404}
      title={
        <>
          {t("error.oops")}
          <br />
          {t("error.something-wrong")}
        </>
      }
      description={t("error.page-not-found")}
    />
  );
};

export default ErrorPage;
